import storage from './storage';

const K = 'crm_sequence_templates_v1';

/** Globale Playbook-Vorlagen (Tage relativ zum Start). */
export const DEFAULT_SEQUENCE_TEMPLATES = [
  {
    id: 'seq_std_outbound',
    name: 'Standard Outbound (7 Tage)',
    steps: [
      { day: 0, label: 'Anruf + kurze Notiz', type: 'call' },
      { day: 2, label: 'E-Mail nachfassen', type: 'email' },
      { day: 5, label: 'Zweiter Anruf', type: 'call' },
    ],
  },
  {
    id: 'seq_deep',
    name: 'Tiefer Funnel (14 Tage)',
    steps: [
      { day: 0, label: 'Erstkontakt', type: 'call' },
      { day: 3, label: 'Nutzen-Mail', type: 'email' },
      { day: 7, label: 'Case-Study senden', type: 'email' },
      { day: 12, label: 'Abschluss-Anruf', type: 'call' },
    ],
  },
];

export const sequencesService = {
  getTemplates() {
    const cur = storage.get(K, null);
    if (Array.isArray(cur) && cur.length) return cur;
    return DEFAULT_SEQUENCE_TEMPLATES;
  },
  setTemplates(list) {
    storage.set(K, list);
  },
  /** Fortschritt pro Lead: { templateId, startedAt, doneStepIndexes: number[] } */
  getProgressMap(userId) {
    const k = userId ? `crm_sequence_progress_u${userId}` : 'crm_sequence_progress';
    return storage.get(k, {});
  },
  setProgressMap(userId, map) {
    const k = userId ? `crm_sequence_progress_u${userId}` : 'crm_sequence_progress';
    storage.set(k, map);
  },
  getProgress(userId, leadId) {
    const m = this.getProgressMap(userId);
    return m[String(leadId)] || null;
  },
  start(userId, leadId, templateId) {
    const m = { ...this.getProgressMap(userId) };
    m[String(leadId)] = {
      templateId,
      startedAt: new Date().toISOString().slice(0, 10),
      doneStepIndexes: [],
    };
    this.setProgressMap(userId, m);
    return m[String(leadId)];
  },
  toggleStepDone(userId, leadId, stepIndex) {
    const m = { ...this.getProgressMap(userId) };
    const cur = m[String(leadId)];
    if (!cur) return null;
    const set = new Set(cur.doneStepIndexes || []);
    if (set.has(stepIndex)) set.delete(stepIndex);
    else set.add(stepIndex);
    m[String(leadId)] = { ...cur, doneStepIndexes: [...set].sort((a, b) => a - b) };
    this.setProgressMap(userId, m);
    return m[String(leadId)];
  },
};
